// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/button.js
import BaseComponent from "./base_component"

export default class Button extends BaseComponent {
  static componentName = "button"

  constructor(element, config = {}) {
    super(element, config)
    if (
      element.matches('button, [role="button"], input[type="button"], input[type="reset"], input[type="submit"]') &&
      !element.hasAttribute("aria-pressed")
    )
      element.setAttribute("aria-pressed", element.classList.contains("active"))
  }

  toggle() {
    if (this.element.disabled || this.element.classList.contains("disabled")) return
    const active = this.element.classList.toggle("active")
    this.element.setAttribute("aria-pressed", active)
  }
}
